// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__27Q7A","colMaxWidth":"Table_colMaxWidth__3W3SZ"};